import '../../App.css'
import { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid'
import { SelectGenericFromTable } from '../universal/Axios';


const PersisterConfigTable = () => {
    const [persisterConfigResultsData, setPersisterConfigResultsData] = useState(undefined);

    useEffect(() => {
        SelectGenericFromTable("select * from persister_config;", setPersisterConfigResultsData)
    }, []);

    const persisterConfigResultsColumns = [
        {
            field: 'id',
            headerName: 'Persister Config ID',
            width: 840,
            renderCell: (params) => (
                <>
                    <a
                        href={'edit-persister-config?id=' + params.row.id}
                    >
                        {params.row.id}
                    </a>
                </>
            ),
        },
        {
            field: 'description',
            headerName: 'Description',
            width: 140,
        },
        {
            field: 'created_date',
            headerName: 'Created Date',
            width: 160
        }
    ];

    let persisterConfigResultsDataRows = persisterConfigResultsData?.filter(data => data != null).map((persisterConfigResults) =>
    ({   
        id: persisterConfigResults.id,
        description: persisterConfigResults.description,
        created_date: persisterConfigResults.created_date
    }))


    if (persisterConfigResultsData === undefined) {
        return (<p>loading...</p>)
    }
    return (
        <DataGrid
            disableSelectionOnClick
            rows={persisterConfigResultsDataRows}
            columns={persisterConfigResultsColumns}
            pagination={true}
            initialState={{
              sorting: {
                    sortModel: [{ field: 'id', sort: 'asc' }],
              },
            }}
            autoHeight
      />
    )
};

export { PersisterConfigTable };
